import select from 'select';

export default class FakeElement {
  text = '';
  container = document.body;
  trigger = null;

  /**
   * @param config
   */
  constructor(config = {}) {
    Object.assign(this, config);
  }

  /**
   * Automatically create, select, copy, clear and destroy.
   * @returns {boolean}
   */
  auto() {
    this.create().select();
    const status = this.copy();
    this.clear().destroy();

    return status;
  }

  /**
   * Create the fake textarea.
   * @returns {FakeElement}
   */
  create() {
    this.destroy();

    let fake = document.createElement('textarea');

    fake.value = this.text;
    this.container.appendChild(fake);
    // Prevent zooming on iOS
    fake.style.fontSize = '12pt';
    // Reset box model
    fake.style.border = '0';
    fake.style.padding = '0';
    fake.style.margin = '0';
    // Move element out of screen horizontally
    fake.style.position = 'absolute';
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    fake.style[isRTL ? 'right' : 'left'] = '-9999px';
    // Move element to the same position vertically
    let yPosition = window.pageYOffset || document.documentElement.scrollTop;
    fake.style.top = `${yPosition}px`;
    fake.setAttribute('readonly', '');

    this.element = fake;

    return this;
  }

  /**
   * Select the content of fake textarea.
   * @returns {FakeElement}
   */
  select() {
    select(this.element);

    return this;
  }

  // noinspection JSMethodCanBeStatic
  /**
   * Copies the current selection.
   * @returns {boolean}
   */
  copy() {
    try {
      return document.execCommand('copy');
    } catch (error) {
    }

    return false;
  }

  /**
   * Clear selection and return focus.
   * @returns {FakeElement}
   */
  clear() {
    // Doesn't really work with the current button.
    // if (this.trigger) {
    //   this.trigger.focus();
    // }

    window.getSelection().removeAllRanges();

    return this;
  }

  /**
   * Remove the fake textarea.
   * @returns {FakeElement}
   */
  destroy() {
    if (this.element) {
      this.container.removeChild(this.element);
      this.element = null;
    }

    return this;
  }
}
